import { Checkbox, FormControlLabel, FormControlLabelProps } from "@mui/material";
import React from "react";
import { FieldValues, useController } from "react-hook-form";

import { FieldPathOfType } from "./formTypes";

interface IProps<TFieldValues extends FieldValues, TName extends FieldPathOfType<TFieldValues, boolean>> {
    name: TName;
    label: FormControlLabelProps["label"];
    disabled?: boolean;
    required?: boolean;
    defaultValue?: boolean;
    className?: string;
    sx?: FormControlLabelProps["sx"];
    onChange?: (event: { target: { value: boolean } }) => void;
}

export function FormCheckbox<
    TFieldValues extends FieldValues = FieldValues,
    TName extends FieldPathOfType<TFieldValues, boolean> = FieldPathOfType<TFieldValues, boolean>,
>({
    name,
    label,
    disabled,
    required,
    defaultValue = false,
    className,
    sx,
    onChange,
}: IProps<TFieldValues, TName>): React.ReactElement | null {
    const {
        field: { ref, value, ...field },
    } = useController({ name, rules: { required, onChange }, defaultValue: defaultValue as never });

    return (
        <FormControlLabel
            {...field}
            control={<Checkbox />}
            inputRef={ref}
            checked={value ?? false}
            disabled={disabled}
            label={label}
            className={className}
            sx={sx}
        />
    );
}
